import RestApiModel from "@/api/Model/RestApiModel";

class UnderwritingToolsOther extends RestApiModel {
  static getResourceEndpoint() {
    return '/CommercialOtherDocuments';
  }
}

export default UnderwritingToolsOther;
